import BaseModel from './base/BaseModel.model';

export default class CvLoading extends BaseModel {

    firstBlock: boolean = false;
    firstCompleted: boolean;

    secondBlock: boolean = false;
    secondCompleted: boolean;

    
    thirdBlock: boolean= false;
    thirdCompleted: boolean;
    
    fourthBlock: boolean = false;
    fourthCompleted: boolean;
    
    fifthBlock: boolean = false;
    fifthCompleted: boolean;
    
    sixthBlock: boolean = false;
    sixthCompleted: boolean;
    
    seventhBlock: boolean;
    seventhCompleted: boolean;

    constructor(){
        super();
        this.init();
    }

    init(){
        this.firstBlock = true;
        this.secondBlock = true;
        this.thirdBlock = true;
        this.fourthBlock = true;
        this.fifthBlock = true;
        this.sixthBlock = true;
    }

    reset(){
        this.firstCompleted = false;
        this.secondCompleted = false;
        this.thirdCompleted = false;
        this.fourthCompleted = false;
        this.fifthCompleted = false;
        this.sixthCompleted = false;
    }
}